import React, { useContext, useEffect, useState } from 'react';
import './styles.scss'
import {  Button, Col, Modal, Row, Select, Table, Form, Tooltip } from 'antd';
import {
    DeleteOutlined,
    ExclamationCircleOutlined,
    WarningOutlined,
    DatabaseOutlined,
  } from '@ant-design/icons';
import { useForm } from 'antd/es/form/Form';
import  { ColumnsType } from 'antd/es/table';
import { SpinerHorizontal } from '../../SpinerHorizontal/SpinerHorizontal';
import { UsersSectionProps, ValuesForm } from './types';
import { Transaction } from '../../../Services/useGetMovements';
import { useGetAllClients } from '../../../Services/useGetAllClients';
import { useGetCurrency } from '../../../Services/useGetCurrency';
import { useOperations } from '../../../Services/useOperations';
import moment from "moment";
import { DatePicker, Space } from 'antd';
import { StylesContext } from '../../../Contexts/UserContext/StylesContext';
import { OperationsContext } from '../../../Contexts/UserContext/OperationsContext';
import { VariablesContext } from '../../../Contexts/UserContext/VariablesContext';
import { DataType } from '../../../Contexts/UserContext/MovementAcountContext';
import { RenderApproved } from '../../RenderApproved';
import RenderOperationType from '../../RenderOperationType';
import { useGetBranch } from '../../../Services/useGetBranch';
import { useGetCashDesk } from '../../../Services/useGetCashDesk';
import { RenderVentanilla } from '../../TableRenders';
import { useGetOperationType } from '../../../Services/useGetOperationType';
import { RenderAccountAmount, RenderAmount, RenderBalance, RenderCheckout, RenderCustomerDestination, RenderCustomerOrigin,  } from './RenderOperationType';
import {  
  RenderNumOperations,
  RenderOP
} from '../../TableRenders';



const OperationSections: React.FC<UsersSectionProps> = () => {
  
  const handleRenderer = (text: string, record: DataType) =>{
    return (
      <div className='currency_action_action_render'>
        {
          record.deleted === 'true' || 
          record.is_deleting_operation === 'true' ||
          record.related_operation_id 
          ? <div></div>
          : <DeleteOutlined 
            onClick={()=>{
              setRowSelect(record)
              setShowConfirmDelete(true)
            }}
          style={{color: '#37bde0'}} />           
        }            
      </div>  
    )      
  }

  const filters = (
      type: 'n°' 
      | 'operation_type_name' | 'approved' | 'deleted' | 'is_deleting_operation' | 'debit' 
      | 'credit'| 'destination_account_id'| 'origin_account_id' | 'destination_checkout_name' | 'origin_checkout_name'
      | 'full_name',
      dataApi: Transaction[]
  ) => {
    let textAndValue: { text: string, value: string }[] = [];
    let uniqueValues = new Set();

    dataApi?.forEach((item) => {
        let code = ''
        let value = ''
        switch(type){
            case 'n°':
                code = item.operation_id?.toString()
                value =  item.operation_id?.toString()
                break;
            case 'operation_type_name':
                code = item.type.name;
                value = item.type.name;
                break;
            case 'approved':
                code = item.approved ? 'Aprobado' : 'No aprobado';
                value = item.approved ? 'true' : 'false';
                break; 
            case 'deleted':
                code = item.deleted ? 'Eliminado' : 'No eliminado';
                value = item.deleted ? 'true' : 'false';
                break;    
            case 'is_deleting_operation':
                code = item.is_deleting_operation ? 'Nota de crédito' : 'No NC';
                value = item.is_deleting_operation ? 'true' : 'false';
                break;  
            case 'debit':
              code = item.debit?.toString();
              value = item.debit.toString();
              break;  
            case 'credit':
              code = item.credit?.toString();
              value = item.credit?.toString();
              break;                 
            case 'full_name':
                code = item.full_name;
                value = item.full_name;
                break; 
            case 'destination_account_id':
              const firstName = item.destination_account?.customer?.first_name;
              const lastName = item.destination_account?.customer?.last_name;
              const customer_id = item.destination_account?.customer?.id
          
              if (firstName && lastName && customer_id) {
                  code = `${firstName} ${lastName}`;
                  value = customer_id?.toString();
              }
              break;  
            case 'origin_account_id':
              const firstName_1 = item.origin_account?.customer?.first_name;
              const lastName_1 = item.origin_account?.customer?.last_name;
              const currencySign_1 = item.origin_account?.currency?.sign;
              const oroginAccountId = item.origin_account?.id?.toString();
          
              if (firstName_1 && lastName_1 && currencySign_1 && oroginAccountId) {
                  code = `${firstName_1} ${lastName_1} ${currencySign_1}`;
                  value = oroginAccountId;
              }
              break;   
            case 'destination_checkout_name':
              const name = item.destination_checkout?.name           
              if (name) {
                  code = `${name}`;
                  value = item.destination_checkout?.id?.toString();
              }
              break;  
            case 'origin_checkout_name':
              const name_destination = item.destination_checkout?.name           
              if (name_destination) {
                  code = `${name_destination}`;
                  value = item.destination_checkout?.id?.toString();
              }
              break;                 
            default:
                code ='';
                value = ''
                break               
        }
      
        if (code && !uniqueValues.has(code)) {
            uniqueValues.add(code);
            textAndValue.push({
                text: code,
                value: value
            });
        }
    });

    textAndValue.sort((a, b) => {
      if (!isNaN(Number(a.text)) && !isNaN(Number(b.text))) {
          return Number(a.text) - Number(b.text); // Para números
      } else {
          return a.text.localeCompare(b.text); // Para strings
      }
    });
    return textAndValue;
  }

  const { data: clients } = useGetAllClients()
  const { data: currencies } = useGetCurrency()
  const { Option } = Select;
  const { getOperationAmount, deleteOperation } = useOperations()
  const { RangePicker } = DatePicker;
  const { adjustedTableHeigthScroll } = useContext(StylesContext)  
  const { setShowForms, modalManager } = useContext(VariablesContext)
  const {data: operation_type} = useGetOperationType()
  const { data: cashs } = useGetCashDesk()
  const { 
    setDataApi, 
    columnsOperationSections, 
    setColumnsOperationSections,
    approvedKey, 
    setApprovedkey,
    deletedKey, 
    setDeletedkey,
    rowSelect,
    setRowSelect,
    showConfirmDelete,
    setShowConfirmDelete
  } = useContext(OperationsContext)


  const [form_operations_filters] = useForm()
  const [loadingTableData, setLoadingTableData] = useState<boolean>(false)
  const [loadingBtn, setLoadingBtn] = useState<{
      search: boolean,
      refresh: boolean
  }>({
      search: false,
      refresh: false
  })

  const [selectedBranch, setSelectedBranch] = useState<number>()

  const {data: branches } = useGetBranch()
    
  const makeColumns = (dataApi: Transaction[])=>{
    if(dataApi){
      const newColumns: ColumnsType<DataType> = [
        {
          title: 'N° ',
          dataIndex: 'operation_id',
          width: 60,
          fixed: 'left',
          className:'cursor-pointer ', 
          render: (text, record)=><RenderNumOperations text={text} record={record}/> ,
          filters: filters('n°', dataApi),
          onFilter: (value, record) => typeof value === 'string' && record.operation_id === value,
          filterSearch: true, 
        },
        {
          title: 'OA',
          dataIndex: 'associated_operation',
          render: (text, record)=><RenderOP text={record.associated_operation ? record.associated_operation : record.related_load_operation_n} record={record}/> ,
          width: 60,
          className: 'cursor-pointer',
        },
        {
          title: 'Usuario',
          dataIndex: 'show_user', 
          className: 'cursor-pointer',
          width: 90,  
          ellipsis: true         
        },  
        {
            title: 'Fecha',
            dataIndex: 'date',
            width: 80,
            className:'cursor-pointer text-center', 
            onFilter: (value, record) => typeof value === 'string' && record.date === value,
            filterSearch: true,     
        },
        {
          title: 'Hora',
          className:'cursor-pointer text-center',
          dataIndex: 'hours',
          width: 60,      
        },
        {
          title: 'Ventanilla',
          dataIndex: 'full_name',
          ellipsis: true,
          width: 90,
          className:'cursor-pointer cell_window',
          render: (text: string, record: DataType) => <RenderVentanilla  text={text} record={record} />,
          filters: filters('full_name', dataApi),
          onFilter: (value, record) => typeof value === 'string' && record.full_name === value,
          filterSearch: true,
        },
        {
          title: 'Aprobado',
          dataIndex: 'approved',
          render: (text: string, record: DataType)=> 
            <RenderApproved 
              text={text} 
              record={record} 
              setDataTable={setDataTable} 
              dataTable={dataTable} 
              callback ={handleSearch}
            />,
          width: 90,
          className:'cursor-pointer', 
          filters: filters('approved', dataApi),
          onFilter: (value, record) => typeof value === 'string' && record.approved === value,      
        },     
        {
          title: 'Operación',
          dataIndex: 'operation_type_name',
          width: 110,
          ellipsis:true,
          className: 'cursor-pointer',
          filters: filters('operation_type_name', dataApi),
          onFilter: (value, record) => typeof value === 'string' && record.operation_type_name === value,
          render: (text, record)=>{return<RenderOperationType text={text} record={record}/>},
        },      
        {
          title: 'TC',
          dataIndex: 'currency_quote',
          className: 'text-center cursor-pointer',
          width: 60,
          ellipsis: true
        },
        {
          title: 'TC USDT',
          dataIndex: 'porcentage_currency_quote',
          className: 'text-center cursor-pointer',
          width: 70,
        },
        {
          title: 'CREDITO EN CAJAS Y CUENTAS CLIENTES',
          children:[
            {
              title: 'Crédito',
              dataIndex: 'credit', 
              width: 130,   
              className:'cursor-pointer  text-right  cell_credit background_cell_credit cell_border_left_white',
              filters: filters('credit', dataApi),
              onFilter: (value, record) => typeof value === 'string' && record.credit === value,
              filterSearch: true,
              render:(text: string, record: DataType)=><RenderAmount text={text} record={record} type={'credit'} data={'destination'}/>,
            },            
            {
              title: 'Sucursal - Caja',
              dataIndex: 'destination_checkout_branch', 
              render: (text, record)=>{ 
                let txt = record.destination_checkout_branch !== '' && record.destination_checkout_name !== '' 
                  ? record.destination_checkout_branch + ' - ' + record.destination_checkout_name
                  : ''
                return <RenderCheckout text={txt} record={record}/>}, 
              className: ' text-right  background_cell_credit cursor-pointer cell_border_left_white',
              width: 120,       
            },
            {
              title: 'Saldo caja',
              dataIndex: 'balance_destination_checkout',
              width: 110,
              className:'cursor-pointer  text-right background_cell_credit',
              render: (text, record)=> <RenderBalance text={text} record={record} type='destination'/>,
            },     
            {
              title: 'Cuenta Cliente', // Cuenta destino
              dataIndex: 'destination_account_id',
              render: (text, record)=><RenderCustomerDestination text={text} record={record}/>,
              className:'cursor-pointer text-right background_cell_credit',  
              ellipsis: true,
              width: 180,   
              filters: filters('destination_account_id', dataApi),
              onFilter: (value, record) => typeof value === 'string' && record.destination_account_customer_id===value,
              filterSearch: true,
            },
            {
              title: 'Saldo cliente', //Cuenta destino
              dataIndex: 'destination_account_balance',
              render: (text, record)=><RenderAccountAmount text={text} record={record} type={'credit'} />,
              className:'cursor-pointer text-right background_cell_credit',  
              ellipsis: true,
              width: 110,   
            },
          ]
        },
        {
          title: 'DÉBITOS EN CAJAS Y CUENTAS CLIENTES',
          children:[
            {
              title: 'Débito',
              dataIndex: 'debit',
              width: 130, 
              className:'cursor-pointer  cell_debit text-right cell_border_left_white cell_border_right_white',
              filters: filters('debit', dataApi),
              onFilter: (value, record) => typeof value === 'string' && record.debit === value,
              filterSearch: true, 
              render:(text: string, record: DataType)=><RenderAmount text={text} record={record} type={'debit'} data={'origin'}/>,
            },    
            {
              title: 'Sucursal - Caja',
              dataIndex: 'origin_checkout_branch',
              render: (text, record)=>{  
                let txt = record.origin_checkout_branch !== '' && record.origin_checkout_name !== '' 
                  ? record.origin_checkout_branch + ' - ' + record.origin_checkout_name
                  : ''
                return <RenderCheckout text={txt} record={record}/>},
              className: ' text-right  cursor-pointer',
              width: 120,       
            },
            {
              title: 'Saldo caja',
              dataIndex: 'balance_origin_checkout',
              width: 110,
              className:'cursor-pointer text-right',
              render: (text, record)=> <RenderBalance text={text} record={record} type='origin'/>,
            },  
            {
              title: 'Cuente cliente', //cuenta origen
              dataIndex: 'origin_account_id',          
              render: (text, record)=><RenderCustomerOrigin text={text} record={record}/>,
              className:'cursor-pointer text-right',  
              ellipsis: true,  
              width: 180, 
              filters: filters('origin_account_id', dataApi),
              onFilter: (value, record) => typeof value === 'string' && record.origin_account_id === value,
              filterSearch: true,
            },  
            {
              title: 'Saldo Cliente', //Cuenta destino
              dataIndex: 'origin_account_balance',          
              render: (text, record)=><RenderAccountAmount text={text} record={record} type={'debit'} />,
              className:'cursor-pointer text-right',  
              ellipsis: true,
              width: 110,   
            },      
          ]
        },
               
        {
          title: 'Descripción',
          dataIndex: 'description',
          className: 'cursor-pointer cell_border_left_white',
          ellipsis: true,
          width: 150,
        },    
        {
          title: 'Eliminar' ,
          dataIndex: 'id',     
          render:  handleRenderer,
          className: 'text-center',
          width: 65,     
          fixed: 'right'
        }, 
      ];
      // const updatedColumns = newColumns.map((item, index) => {
      //     let key = index + 1
      //     if(item.title ==='Eliminar'){
      //       setDeletedkey(key.toString()) 
      //     }
      //     if(item.title === 'Aprobado'){
      //       setApprovedkey(key.toString()) 
      //     }
      //     return({
      //       ...item,
      //       key: key, // Nueva propiedad "key"
      //     })}
      //   );
      const updatedColumns = addKeys(newColumns)
      if(updatedColumns){
        setColumnsOperationSections(updatedColumns) 
      } 
          
    }
  } 

  const addKeys = (columns:ColumnsType<DataType>)=>{
      let key = 0
      let updateColumns = columns.map((item, index)=>{  
        if("children" in item){
          const newChildren = item.children.map((child) => {
            key = key + 1
            return {
              ...child,
              key
            }
          })
  
          return {
            ...item,
            children: newChildren
          }
        }    
        else{
          key = key + 1
          if(item.title ==='Eliminar'){
            setDeletedkey(key.toString()) //24
          }
          if(item.title === 'Aprobado'){
            setApprovedkey(key.toString()) 
          }
          return({
            ...item,
            key: key, // Nueva propiedad "key"
          })
        }}
      )
      return updateColumns
    }
  

  const [currencySelected, setCurrencySelected] = useState<{
    id: number,
    name: string,
    sign: string
  }>()

  const {
    dataTable, 
    setDataTable,
    mutate, 
    setMutate, 
    sectionsFilters, 
    setSectionsFilters,
  } = useContext(OperationsContext)

  const mandatory = [
    {
      required: true,
      message:'Este campo es obligatorio'
    }
  ] 

  const errorCustomers = 'NO HAY CLIENTES CREADOS PARA HACER UNA BÚSQUEDA POR CLIENTE. CREE UNO EN: ADMINISTRACIÓN => CLIENTES.'
  const errorMoney = 'NO HAY MONEDAS CREADAS PARA HACER UNA BÚSQUEDA POR MONEDA. CREE UNA EN: ADMINISTRACIÓN => MOEDAS.'
  
  useEffect(()=>{
    if(dataTable.length === 0){
      handleSearch(true, false)    
    }
    if(sectionsFilters){
      form_operations_filters.setFieldsValue({
        operation_type: sectionsFilters.operation_type || undefined,
        customer: sectionsFilters.customer || undefined,
        currency: sectionsFilters.currency || undefined,
        branch: sectionsFilters.branch || undefined,
        checkout: sectionsFilters.chekout
      })
      if(sectionsFilters.branch){
        setSelectedBranch(sectionsFilters.branch.key)
      }
    }
  },[])  

  useEffect(()=>{
    if(mutate){
      handleSearch(false, false)  
      setMutate(false)
    }
  },[mutate])

  const rowData = async (data: Transaction[]) => {
    if (!data) return; 
    const promises = data.map(async (transaction) => {
      let created_by: string | undefined
      let updated_by: string | undefined
      let created_at: string = moment(transaction.created_at).format('DD-MM-YYYY') || ''
      let updated_at: string = moment(transaction.updated_at).format('DD-MM-YYYY') || ''      
      let created_at_hr: string | undefined = moment(transaction.created_at).format('HH:mm:ss') || undefined
      let updated_at_hr: string | undefined = moment(transaction.updated_at).format('HH:mm:ss') || undefined
      let related_load_operations_valid: 'false' | 'true' = 'false'

      if((transaction.type.id === 1 || transaction.type.id === 2 || transaction.type.id === 3 || transaction.type.id === 4) &&
          transaction.related_load_operation 
      ){
          related_load_operations_valid = transaction.related_load_operation.deleted ? 'true' : 'false'
      }

      if(transaction.created_by){
        created_by = transaction.created_by.first_name + ' ' +  transaction.created_by.last_name
      }
      if(transaction.updated_by){
          updated_by = transaction.updated_by.first_name + ' ' +  transaction.updated_by.last_name
      }
      return {
        approved: transaction.approved ? 'true' : 'false',
        associated_operation: transaction.related_operation_user_id?.toString() || undefined,
        balance_destination_checkout: transaction.destination_checkout_balance?.toString() || '',
        balance_origin_checkout: transaction.origin_checkout_balance?.toString() || '',
        can_be_approved: transaction.can_be_approved ? 'true' : ' false',
        commission: transaction.commission || '',
        created_at: created_at,
        credit: transaction.credit?.toString() || '',
        credit_number: transaction.credit?.toString() || '',
        currency_quote_buy_price: transaction.currency_quote_buy_price || undefined,
        currency_quote_sell_price: transaction.currency_quote_sell_price|| undefined,
        currency_sale: transaction.currency_sale ? 'true' : 'false',
        customer_first_name: transaction.customer?.first_name || '',
        customer_id: transaction.customer?.id?.toString() || '',
        customer_last_name: transaction.customer?.last_name || '',
        date: updated_at ? updated_at : created_at,
        hours: updated_at_hr ? updated_at_hr : created_at_hr,
        debit: transaction.debit?.toString() || '',
        debit_number: transaction.debit?.toString() || '',
        deleted: transaction.deleted ? 'true' : 'false',
        deposit_costs: transaction.deposit_costs || undefined,
        deposit_operation_approved: transaction.deposit_operation_approved ? 'true' : ' false',
        description: transaction.description || '',
        destination_account_balance: transaction.destination_account_balance?.toString() || '',
        destination_account_currency_id: transaction.destination_account?.currency?.id?.toString() || '',
        destination_account_currency_name: transaction.destination_account?.currency?.name || '',
        destination_account_currency_sign: transaction.destination_account?.currency?.sign || '',
        destination_account_customer_id: transaction.destination_account?.customer?.id?.toString() || '',
        destination_account_customer_last_name: transaction.destination_account?.customer?.last_name || '',
        destination_account_customer_name: transaction.destination_account?.customer?.first_name || '',
        destination_account_id: transaction.destination_account?.id?.toString() || '',
        destination_checkout_balance: transaction.destination_checkout?.balance?.toString() || '',
        destination_checkout_currency_id: transaction.destination_checkout?.currency?.id?.toString() || '',
        destination_checkout_currency_name: transaction.destination_checkout?.currency?.name || '',
        destination_checkout_currency_sign: transaction.destination_checkout?.currency?.sign || '',
        destination_checkout_id: transaction.destination_checkout?.id?.toString() || '',
        destination_checkout_name: transaction.destination_checkout?.name || '',
        destination_checkout_branch: transaction.destination_checkout?.branch?.name || '',
        destination_checkout_branch_id: transaction.destination_checkout?.branch?.id?.toString() || '',
        extraction_operation_approved: transaction.extraction_operation_approved ? 'true' : ' false',
        extraction_costs: transaction.extraction_costs || undefined,
        full_name: transaction.full_name || '',
        fixed_commission: transaction?.fixed_commission?.toString() || '',
        id: transaction.id?.toString(),
        is_deleting_operation: transaction.is_deleting_operation ? 'true' : 'false',
        is_sale: transaction.currency_sale === true ? 'true' : transaction.currency_sale === false ? 'false' : undefined,
        main_currency_id: transaction.main_currency?.id.toString() || '',
        main_currency_sign: transaction.main_currency?.sign || '',
        main_operation_id: transaction.main_operation_id?.toString() || '',
        operation_id: transaction.operation_id?.toString() || '',
        operation_type_id: transaction.type.id?.toString(),
        operation_type_name: transaction.type.name,
        origin_account_balance: transaction.origin_account_balance?.toString() || '',
        origin_account_currency_id: transaction.origin_account?.currency?.id?.toString() || '',
        origin_account_currency_name: transaction.origin_account?.currency?.name || '',
        origin_account_currency_sign: transaction.origin_account?.currency?.sign || '',
        origin_account_customer_id: transaction.origin_account?.customer?.id?.toString() || '',
        origin_account_customer_last_name: transaction.origin_account?.customer?.last_name || '',
        origin_account_customer_name: transaction.origin_account?.customer?.first_name || '',
        origin_account_id: transaction.origin_account?.id?.toString() || '',
        origin_checkout_balance: transaction.origin_checkout?.balance?.toString() || '',
        origin_checkout_currency_id: transaction.origin_checkout?.currency.id?.toString() || '',
        origin_checkout_currency_name: transaction.origin_checkout?.currency?.name || '',
        origin_checkout_currency_sign: transaction.origin_checkout?.currency?.sign || '',
        origin_checkout_id: transaction.origin_checkout?.id?.toString() || '',
        origin_checkout_name: transaction.origin_checkout?.name || '',
        origin_checkout_branch: transaction.origin_checkout?.branch?.name ||  '',
        origin_checkout_branch_id: transaction.origin_checkout?.branch.id?.toString() || undefined,
        related_load_operation: related_load_operations_valid,
        related_load_operation_id: transaction.related_load_operation_id?.toString() || undefined, 
        related_load_operation_n: transaction.related_load_operation?.operation_id.toString() || undefined,
        related_operation_id: transaction.related_operation_id?.toString() || undefined, 
        secondary_currency_id: transaction.secondary_currency?.id?.toString() || undefined,
        secondary_currency_name: transaction.secondary_currency?.name || undefined,
        secondary_currency_sign: transaction.secondary_currency?.sign || undefined,
        supplier_commission: transaction.supplier_commission,
        updated_at:updated_at,
        usdt_quote_percentage: transaction.usdt_quote_percentage ? transaction.usdt_quote_percentage : undefined,
        usdt_sale: transaction.usdt_sale === true ? 'true' : transaction.usdt_sale === false ? 'false' : undefined, 
        windows_operation:  transaction.windows_operation === true ? 'true' : transaction.windows_operation === false ? 'false' : undefined,
        currency_quote:
          transaction.currency_quote_buy_price != null
            ? Number(transaction.currency_quote_buy_price).toFixed(2)
            : transaction.currency_quote_sell_price != null
              ? Number(transaction.currency_quote_sell_price).toFixed(2)
              : undefined,
        porcentage_currency_quote: transaction.usdt_quote_percentage ? Number(transaction.usdt_quote_percentage).toFixed(2) + '%' : undefined,
        approved_date: transaction.approved_date ? moment(transaction.approved_date).format('DD-MM-YYYY') : undefined,
        transfer_costs: transaction.transfer_costs || undefined,   
        client_pays_costs: transaction.client_pays_costs === true ? 'true' : transaction.usdt_sale === false ? 'false' : undefined,   
        created_by: transaction.created_by?.first_name ||' ' + ' ' + transaction.created_by?.last_name ||' ',
        updated_by: transaction.updated_by?.first_name ||' '+ ' ' + transaction.updated_by?.last_name ||' ',
        show_user: updated_by 
            ? updated_by 
            : created_by
                ? created_by
                : '',                  
      };
    });
  
    try {
      const filterData = await Promise.all(promises);
      setDataTable([...filterData]);
    } catch (error) {
      console.error('Error processing row data:', error);
    }
  };

  const callbackEliminate = () =>{
      setLoadingTableData(false)
      setRowSelect(undefined)        
      setShowConfirmDelete(false)
  }

   
  const ModalConfirmDelete = React.memo( () => {
    return(
        <Modal
            className='transactions_section_icon'
            title="Eliminar"
            open={showConfirmDelete}
            onOk={async()=>{
                if(rowSelect && rowSelect.id){
                  const data = await deleteOperation(callbackEliminate, +rowSelect.id)
                  if(data){
                    handleSearch(false, false)
                  }
                }}}
            onCancel={()=>setShowConfirmDelete(false)}
            okText="Eliminar"
            cancelText="Cancelar"
        >
            <p>¿Estás seguro de que desea eliminar operación N° {rowSelect?.operation_id} ?</p>
        </Modal>
    )
  })   

  const onClickRow = (record: DataType) =>{         
    if(record){
      setRowSelect(record);
    }  
  }    
    
  const handleSearch = async(loadingTable: boolean, loadingRefresh: boolean) =>{
      if(loadingTable){
        setLoadingTableData(true)
      } 
      if(loadingRefresh){
        setLoadingBtn({
          search: false,
          refresh: true
        })
      }

      let formData:{
        date: {$d: string}[],
        operation_type: any,
        customer: ValuesForm, 
        currency: ValuesForm,
        branch: ValuesForm,
        checkout: ValuesForm        
      } = form_operations_filters.getFieldsValue()

      let start_date = formData.date && formData.date[0] ? moment(formData.date[0].$d).format('YYYY-MM-DD') : undefined
      let end_date = formData.date && formData.date[1] ? moment(formData.date[1].$d).format('YYYY-MM-DD') : undefined
      let currency =  formData.currency || undefined  
      let customer =  formData.customer || undefined
      let operation_type = formData.operation_type || undefined 
      let branch = formData.branch || undefined
      let checkout = formData.checkout || undefined
      
      let values ={
        customer_id: customer && customer.key,
        currency_id: currency && currency.key,  
        start_date: start_date,
        end_date: end_date,
        operation_type: operation_type && operation_type.key,
        branch_id: branch && branch.key,
        checkout_id: checkout && checkout.key
      }

     // checkAccountBalance()
      const data = await getOperationAmount(
        callbackEliminate,
        values
      )  
      if(data){
        makeColumns(data)
        rowData(data)
        setDataApi(data)
        setSectionsFilters({
          date: {
            to: formData.date && formData.date[0] || undefined,
            from: formData.date && formData.date[1] || undefined
          },
          currency:  formData.currency || undefined,          
          customer: formData.customer || undefined,
          operation_type: formData.operation_type || undefined,
          branch:   formData.branch || undefined,
          chekout: formData.checkout || undefined
        })
      } 
      if(loadingRefresh){
        setLoadingBtn({
          search: false,
          refresh: false
        })
      }  
  }


  return( 
    <>
      <ModalConfirmDelete/> 
      <div className='transactions_section transactions_section_container hover_row'>  
          <Row
            className='global_title_section'  
          >
            <Col
              style={{
                display: 'flex',
                alignItems: ' center',
              }}
            >
              <h3> <DatabaseOutlined style={{fontSize: 18, marginRight: '10px', color: '#37bde0'}}/>TRANSACCIONES</h3> 
            </Col>
          </Row>                                          
          <Row 
            className='global_button_box'
            style={{
              display:'flex',
              justifyContent: 'space-between',
              alignItems:'center'
            }}
          >              
            <Col >
              <Form
                layout='inline'
                onFinish={()=>handleSearch(true, false)}
                id='form_operations_filters' 
                form={form_operations_filters}
              >
                <Form.Item
                    name='date'
                >
                  <RangePicker 
                    style={{width: 240}}
                    placeholder={['Desde', 'Hasta']} 
                  />
                </Form.Item>
                <Form.Item
                    name='operation_type'
                >
                  <Select                           
                    labelInValue  
                    loading={!operation_type }
                    placeholder={!operation_type ? 'Cargando campos...' : 'Operación'}      
                    style={{minWidth: '100px'}}    
                    showSearch 
                    allowClear                                                 
                  >
                      {operation_type && operation_type.map((item) => (
                          <Option value={item.name} key={item.id} >
                            {item.name}
                          </Option>
                      ))} 
                  </Select>
                </Form.Item>
                <Form.Item
                  name='branch'
                >
                  <Select                           
                      labelInValue  
                      loading={!currencies}
                      placeholder={!currencies ? 'Cargando...' : 'Sucursal'}                       
                      style={{minWidth: '100px'}}
                      //onChange={(e, value) => onChangeBranch(e, value)}
                      showSearch
                      allowClear 
                      onChange={(e:{key: number})=>{
                        if(e?.key){
                          setSelectedBranch(e.key)
                          form_operations_filters.setFieldsValue({
                            checkout: undefined
                          })
                        }else{
                          setSelectedBranch(undefined)
                        }
                        
                      }}
                  >
                      {branches && branches && branches.map((item) => (
                          item.id !== 0 &&
                          <Option value={item.name} key={item.id} >
                            {item.name}
                          </Option>
                      ))} 
                  </Select>
                </Form.Item>   
                <Form.Item
                  name='checkout'
                >
                  <Select                           
                      labelInValue  
                      loading={!currencies}
                      placeholder={!currencies ? 'Cargando ...' : 'Caja'}                       
                      style={{minWidth: '150px'}}
                      //onChange={(e, value) => onChangeBranch(e, value)}
                      showSearch
                      allowClear 
                  >
                    {
                      selectedBranch
                        ? cashs && cashs && cashs
                            .filter((item)=>item.branch.id === selectedBranch || item.branch.id === 0)
                            .map((item) => (
                            <Option value={item.name} key={item.id} >
                              {item.name}
                            </Option>
                          ))
                        : cashs && cashs && cashs.map((item) => (
                            <Option value={item.branch.name + ' - ' + item.name} key={item.id} >
                              {item.branch.name + ' - ' + item.name}
                            </Option>
                          ))
                    }
                  </Select>
                </Form.Item>              
                <Form.Item
                    name='customer'
                >
                  <Select                           
                    labelInValue  
                    loading={!clients}
                    placeholder={!clients ? 'Cargando campos...' : 'Cliente'}      
                    style={{minWidth: '150px'}}   
                    showSearch  
                    allowClear                                                 
                  >
                      {clients && clients.map((item) => (
                          <Option value={item.first_name + ' ' + item.last_name} key={item.id} >
                            {item.first_name + ' ' + item.last_name}
                          </Option>
                      ))} 
                  </Select>
                </Form.Item>
                {/* <Form.Item
                    name='currency'
                >
                  <Select                           
                      labelInValue  
                      loading={!currencies}
                      placeholder={!currencies ? 'Cargando monedas...' : 'Moneda'}                       
                      style={{minWidth: '100px'}}
                      onChange={(e, value) => onChangeCurrency(e, value)}
                      showSearch
                      allowClear 
                  >
                      {currencies && currencies && currencies.map((item) => (
                          <Option value={item.name} key={item.id} sign={item.sign} >
                            {item.name}
                          </Option>
                      ))} 
                  </Select>
                </Form.Item> */}
                <Form.Item>
                  <Button
                  type='primary'
                  className='movements_section_btn'
                  htmlType='submit'
                  loading={loadingBtn.search}
                  >
                    Buscar
                  </Button>
                </Form.Item>
                <Button 
                    type='primary'
                    className='allCheckout_section_btn'
                    onClick={()=>handleSearch(false, true)}
                    //disabled={!branchSelected}
                    style={{marginRight: 10}}
                    loading={loadingBtn.refresh}
                >
                    Refresh                        
                </Button>   
                <Tooltip
                  title= 'Seleccione uno o varios filtros para hacer una búsqueda.'
                  className='cursor-pointer'
                >
                  <ExclamationCircleOutlined style={{color: 'orange'}}/>
                </Tooltip>
              </Form>                               
            </Col>  
                          
          </Row>
          {((clients && clients.length === 0) || (currencies && currencies.length === 0)) &&
            <Row
              style={{ 
                paddingLeft: '30px',
                paddingBottom: '10px',
                display: 'flex',
                flexDirection: 'column'
              }}
            >
              {clients && clients.length === 0 && (
                <span style={{color: '#ff6161', fontFamily: 'monospace'}}>
                  <WarningOutlined 
                    style={{marginRight: '10px', marginTop: '10px', color: '#71e3ff'}} 
                  /> 
                  {errorCustomers}
                </span>
              )}
              {
                currencies && currencies.length === 0 && (
                <span style={{color: '#ff6161', fontFamily: 'monospace'}}>
                  <WarningOutlined 
                    style={{marginRight: '10px', marginTop: '10px', color: '#71e3ff'}} 
                  /> 
                  {errorMoney}
                </span>
              )}
            </Row>
          }
          <Row 
            style={{
                display:'flex',
                justifyContent: 'center',
                width: '100%',
                height: '85%',
                padding: '0px 30px',                        
                border: '1px solid   #645fca6c'
            }}
          >
            { loadingTableData && <SpinerHorizontal/>}
            { !loadingTableData && dataTable
                ?
                  <Table 
                    style={{
                        width: '100%',
                        marginTop: '1%'
                    }}                    
                    columns={columnsOperationSections} 
                    dataSource={dataTable}  
                    scroll={{ y: adjustedTableHeigthScroll, x: 800 }}                                   
                    pagination={{
                        pageSize: 50,
                        showSizeChanger: false,                                      
                    }}
                    rowClassName={(record)=>{  return record.deleted === 'true' || record.is_deleting_operation === 'true' ? 'cell_deleted custom-table' : 'custom-table'}}
                    onRow={(record, ) => ({
                      onClick: (event) => {
                        if(record.is_deleting_operation === 'true'){
                          return
                        }  
                        if (record.operation_type_id !== '12' && record.operation_type_id !== '13' && record.operation_type_id !== '8') {

                          const approvedCell = event.currentTarget.querySelector(`td:nth-child(${approvedKey})`); 
                          const deleteCell = event.currentTarget.querySelector(`td:nth-child(${deletedKey})`);
                      
                          // Verifica si el clic ocurrió en las celdas "Aprobado" o "Eliminar"
                          if ((approvedCell && approvedCell.contains(event.target)) || (deleteCell && deleteCell.contains(event.target))) {
                            return;
                          }
                      
                          // Llamada al manejador de clic
                          onClickRow(record);
                          modalManager(record)  
                         
                        }
                      }
                    })}
                  /> 
                : 
                 <>
                 </>
            }                             
          </Row>             
      </div>
    </>
  )
};

export default OperationSections;

